import { tv } from 'tailwind-variants';

const baseInputStyles = tv({
  base: `
    iris:flex
    iris:h-(--comp-size-height-input)
    iris:w-full
    iris:items-center
    iris:justify-between
    iris:gap-x-(--base-space-px-16)
    iris:rounded-(--comp-size-radius-input)
    iris:border-(length:--comp-size-border-input)
    iris:px-(--comp-space-padding-input-horizontal)
    iris:py-(--comp-space-padding-text-input-vertical)
    iris:text-(length:--comp-type-size-input-value)
    iris:leading-(--comp-type-leading-input-value)
    iris:font-(--comp-type-weight-input-value)
    iris:outline-none
    iris:hover:border-(--comp-color-border-input-hover)
    iris:disabled:cursor-not-allowed
    iris:disabled:opacity-(--sem-opacity-interactive-disabled)
  `,
  variants: {
    inverse: {
      false: `
        iris:border-(--comp-color-border-input-rest)
        iris:bg-(--comp-color-background-input-rest)
        iris:text-(--comp-color-content-input-value-rest)
        iris:placeholder:text-(--comp-color-content-input-placeholder-rest)
        iris:hover:bg-(--comp-color-background-input-hover)
        iris:hover:text-(--comp-color-content-input-value-hover)
        iris:hover:placeholder:text-(--comp-color-content-input-placeholder-hover)
        iris:focus:bg-(--comp-color-background-input-active)
        iris:focus:placeholder:text-(--comp-color-content-input-placeholder-active)
        iris:focus-visible:ring-offset-2
      `,
      true: `
        iris:border-(--comp-color-border-input-inverse-rest)
        iris:bg-(--comp-color-background-input-inverse-rest)
        iris:text-(--comp-color-content-input-value-inverse-rest)
        iris:placeholder:text-(--comp-color-content-input-placeholder-inverse-rest)
        iris:hover:border-(--comp-color-border-input-inverse-hover)
        iris:hover:bg-(--comp-color-background-input-inverse-hover)
        iris:hover:text-(--comp-color-content-input-value-inverse-hover)
        iris:hover:placeholder:text-(--comp-color-content-input-placeholder-inverse-hover)
        iris:focus:bg-(--comp-color-background-input-inverse-active)
        iris:focus:text-(--comp-color-content-input-value-inverse-active)
        iris:focus:placeholder:text-(--comp-color-content-input-placeholder-inverse-active)
        iris:focus-visible:ring-(--comp-color-border-input-inverse-active)
      `
    }
  }
});

export { baseInputStyles as default };
